// extracted by mini-css-extract-plugin
module.exports = {"embed-modal__info":"EmbedModal_embed-modal__info__dT0B7","embed-modal":"EmbedModal_embed-modal__1M89o","embed-modal__buttons":"EmbedModal_embed-modal__buttons__XUpJq"};